import { render, staticRenderFns } from "./AddComment.vue?vue&type=template&id=48119035&scoped=true&"
import script from "./AddComment.vue?vue&type=script&lang=ts&"
export * from "./AddComment.vue?vue&type=script&lang=ts&"
import style0 from "./AddComment.vue?vue&type=style&index=0&id=48119035&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48119035",
  null
  
)

export default component.exports